// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"__400w-rigid-solar-panel_productcontent__mFWmP"};